<template>
<div class="chapter">
<div class="inner_page">
<a id="pv"></a>
<p class="center sink">
<em>To Joyce, Anne D., Elise and Jack, <br/>the ultimate home team advantage</em>
</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?2bababd9